// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import StarFilledSvg from "@ant-design/icons-svg/es/asn/StarFilled";
import AntdIcon from '../components/AntdIcon';

var StarFilled = function StarFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: StarFilledSvg
  }));
};

StarFilled.displayName = 'StarFilled';
export default React.forwardRef(StarFilled);